import { useRef } from 'react'

import { useChatSendController } from '@/hooks/useChatSendController'

import { ComposerQueue } from './ComposerQueue'
import { ComposerFormRowRef, ComposerInputRow } from './ComposerInputRow/ComposerInputRow'

export interface ComposerProps {
  autoFocus?: boolean
  onToolSelected?: (tool: any) => void
  multiUser?: boolean
  participantIds?: string[]
}

export const Composer = ({ autoFocus, multiUser = false, participantIds }: ComposerProps) => {
  const composerFormRef = useRef<ComposerFormRowRef>({
    setValue: () => {},
    getDraft: () => ({ value: '', attachments: [] }),
    setDraft: () => {},
    clearDraft: () => {}
  } as ComposerFormRowRef)
  const {
    pendingKey,
    queuedMessages,
    activeChatStatus,
    activeChatId,
    handleSubmit,
    handleStop,
    handleQueuedClick,
    removeQueuedMessage
  } = useChatSendController({ composerFormRef, multiUser, participantIds })

  return (
    <div className='mp-agent-composer-wrapper'>
      <div className='mp-agent-composer'>
        <ComposerQueue
          queuedMessages={queuedMessages}
          onSendQueued={handleQueuedClick}
          onRemoveQueued={(id) => removeQueuedMessage(pendingKey, id)}
        />
        <ComposerInputRow
          status={activeChatStatus}
          ref={composerFormRef}
          autoFocus={autoFocus}
          activeChatId={activeChatId}
          onStop={handleStop}
          onSubmit={handleSubmit}
        />
      </div>
    </div>
  )
}
export default Composer
